import { Grid, Pagination, useTheme } from '@mui/material';
import HotelCard from './HotelCard';
import { useSelector } from 'react-redux';
import NoResultsMessage from './NoResultsMessage';
import HotelCardSkeleton from '../SharedHotelCardContent/HotelCardSkeleton';
import { useState, useEffect } from 'react';

const HotelCardSkeletonWrapper = props => <HotelCardSkeleton {...props} />;

const HotelList = ({
  isMobile = false,
  viewFullWidhtMap = false,
  hotelsWithPagination = [],
  handleCardMouseEnter = () => {},
  handleCardMouseLeave = () => {},
  tokenMap,
  total_passengers,
  getFavConfig,
  hotelSearchResults = {},
  sites,
  pageQuantity = 1,
  actualPage = 1,
  setActualPage = () => {},
  aboutSection,
  getFormattedPrice,
  business_types,
  isLoadingResults,
  allFilteredHotels = [],
  hotReferenceCities,
  searchInfo,
  showProgress,
  onMoveMap,
}) => {
  const { user } = useSelector(state => state.userInfo);
  const [shouldScroll, setShouldScroll] = useState(false);

  const theme = useTheme();

  const showContainer = !viewFullWidhtMap;
  const isEmptyFiltered = allFilteredHotels.length === 0;
  const isEmptyPage = hotelsWithPagination.length === 0;

  const totalExpected = 20;
  const skeletonCount = Math.max(
    totalExpected - hotelsWithPagination.length,
    0
  );

  const handlePageChange = (_, page) => {
    setActualPage(page);
    setShouldScroll(true);
  };

  useEffect(() => {
    if (shouldScroll && aboutSection?.current) {
      aboutSection.current.scrollIntoView({ behavior: 'smooth' });
      setShouldScroll(false);
    }
  }, [actualPage, shouldScroll]);

  if (!showContainer) return null;

  if (isEmptyFiltered) {
    return (
      <Grid
        container
        rowSpacing={{ xs: 1, sm: 2, md: 2 }}
        columnSpacing={{ xs: 1, sm: 3, md: 3 }}
        sx={{ overflow: 'auto', position: 'relative', width: '100%' }}
      >
        <NoResultsMessage message="No se encontraron hoteles con los filtros seleccionados." />
      </Grid>
    );
  }

  return (
    <Grid
      container
      rowSpacing={{ xs: 1, sm: 2, md: 2 }}
      columnSpacing={{ xs: 1, sm: 3, md: 3 }}
      id="GRIDITECONTAINERMLISTCARD"
    >
      {hotelsWithPagination.map((hotel, index) => (
        <Grid
          item
          xs={12}
          sm={4}
          key={`${hotel.id_hotel}-${hotel.id_provider}-${index}`}
          id={`GRIDMAPHOTELCARDS-${index}`}
        >
          <HotelCard
            onMoveMap={onMoveMap}
            hotel={hotel}
            tokenMap={tokenMap}
            total_passengers={total_passengers}
            getFavConfig={getFavConfig}
            hotReferenceCities={hotReferenceCities}
            fav_messages={hotelSearchResults.fav_messages}
            sites={sites}
            getFormattedPrice={getFormattedPrice}
            business_types={business_types}
            user={user}
            isMobile={isMobile}
            searchInfo={searchInfo}
            onCardMouseEnter={() => handleCardMouseEnter(hotel)}
            onCardMouseLeave={handleCardMouseLeave}
          />
        </Grid>
      ))}

      {isEmptyPage && (
        <Grid item xs={12} id="NORESULTSMSG">
          <NoResultsMessage
            message={showProgress ? 'Cargando...' : undefined}
          />
        </Grid>
      )}

      {Array.from({ length: isLoadingResults ? skeletonCount : 0 }).map(
        (_, idx) => (
          <HotelCardSkeletonWrapper
            key={`skeleton-${+idx}`}
            idx={idx}
            user={user}
          />
        )
      )}

      {hotelsWithPagination.length > 0 && (
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}
          id="HOTELPAGINATION"
        >
          <Pagination
            count={pageQuantity}
            page={actualPage}
            onChange={handlePageChange}
            sx={{
              '& .MuiPaginationItem-root.Mui-selected': {
                backgroundColor: theme.primary,
                color: theme.text1,
                '&:hover': { bgcolor: theme.primary, color: theme.text1 },
              },
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default HotelList;
